<template>
	<div>
		<div class="flexcenter" id="search-wrapper" style="" :class="this.disabled ? 'disabled' : 'enabled' "
			:title="this.title">
			<Icon v-if="this.spinning" fileName="w3_spinner_grey" class="spinner"
				style="margin-right:5px;margin-left:5px;width:20px;height:20px;" />

			<Icon v-if="!this.spinning" :fileName="this.disabled ? 'w3_search_lighter' : 'w3_search_light' "
				style="margin-right:5px;margin-left:5px;width:20px;height:20px;" :link="!this.disabled" />


			<input class="search-input" type="text" :placeholder="this.placeholder" :value="this.filterInput"
				@input="$emit('update:filterInput', $event.target.value)" @keypress.enter="this.enterPressed()"
				style="font-size:16px;border:0px;outline: none;" :disabled="this.disabled" />

			<img v-if="this.filterInput" src="@/assets/w3_button_close_light.png" @click="$emit('update:filterInput', '');
			this.enterPressed();" style="margin-right:5px;margin-left:5px;width:20px;height:20px;">


			<div id="active-filter-wrapper" class="desktop" style="">
				<ActiveFilterList layout="desktop" />
			</div>

			<div class="mobile">
				<ActiveFilterList layout="mobile" />
			</div>




			<Button v-if="!this.disabled" label="Sök" @click.stop="this.enterPressed()" />
			<Button v-if="this.disabled" label="Sök" class="grey" style="cursor: default;" />

		</div>
		<div v-if="this.filterInput == 'test' " class="center drop-shadow"
			style="position:absolute;height:30px;width:100%;background:var(--grey-4);z-index:40;border-radius: 0px 0px 5px 5px;">
			<div class="flexcenter" style="padding:5px;">
				<div v-for="(sort) in this.sortList" :key="sort.name"
					style="background:var(--grey-6);padding:2px;font-size: 80%;font-weight: bold;color:white;border-radius: 5px;margin-right:2px;padding-left:5px;padding-right:5px;">
					{{ sort.name }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { STORE_COMMIT, STORE_GETTER, STORE_SORT } from '../../store/store';
import ActiveFilterList from './ActiveFilterList.vue';



export default {
	name: "SearchProductTextfield",
	components: { ActiveFilterList },
	mixins: [],
	props: {
		filterInput: String,
		spinning: Boolean
	},
	data() {
		return {
			sortList: [{name: "TEST"}],
		};
	},
	computed:{
		searchProductConfig() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},

		categoryFilterLabel(){
			return this.searchProductConfig?.category?.name
		},

		mcFilterLabel() {
			var mc = "";

			if (this.searchProductConfig?.brand){
				mc = this.searchProductConfig?.brand?.name
			}

			if (this.searchProductConfig?.mc){
				mc = mc + ' ' + this.searchProductConfig?.mc?.modelName
			}

			if (this.searchProductConfig?.year) {
				mc = mc + ' ' + this.searchProductConfig?.year?.year
			}

			return mc
		},

		manufactorFilterLabel(){
			return this.searchProductConfig?.manufactor?.name
		},

		filterLabel(){
			var count = 0;

			if (this.categoryFilterLabel){
				count++;
			}

			if (this.mcFilterLabel && this.mcFilterLabel != "") {
				count++;
			}

			if (this.manufactorFilterLabel) {
				count++;
			}

			if (count === 0){
				return null;
			}

			return count + " filter";
		},
		placeholder(){
			if (this.debug){
				return "Sök, PID:productId"
			}
			if (this.disabled){
				return "För att fritextsöka så välj Alla produkter, nu visas bara ett urval av produkter"
			}

			return "Sök efter produkter, tillverkare, mc-modeller...";
		},
		title(){
			return this.placeholder
		},
		disabled(){
				return !this.$store.getters[STORE_GETTER.PRODUCT_SEARCH_ENABLED];
		},
		rebuildingSearchModel(){
			return this.$store.getters[STORE_GETTER.REBUILDING_SEARCH_MODEL];
		}

		

	},
	watch: {
		filterInput(text) {

			if (!this.disabled){
				this.$emit("showProductSearchPopover");
			}
			
			
			if (text && text.length > 0){
				this.$store.commit(STORE_COMMIT.SET_SORT, STORE_SORT.SORT_SEARCH)
			}else{
				this.$store.commit(STORE_COMMIT.SET_SORT, STORE_SORT.SORT_DEFAULT)
			}
			
		}
	},
	
	methods: {
		enterPressed(){
			this.$emit("enterPressed");
			this.$emit("closeProductSearchPopover");
		},

		removeCategory(){
			this.searchProductConfig.category = null;
		},
		

		removeManufactor() {
			this.searchProductConfig.manufactor = null;
		},

		removeMc() {
			this.searchProductConfig.brand = null;
			this.searchProductConfig.mc = null;
			this.searchProductConfig.year = null;
		},

		removeAll(){
			this.removeCategory();
			this.removeManufactor();
			this.removeMc();
		},


	},
	created() {
		
	}
};
</script>

<style scoped>

div#search-wrapper{
	margin-top: 10px;
		width: auto;
		border: 1px solid var(--grey-5);
		height: 36px;
		border-radius: 5px;
		background: white;
}

div#search-wrapper.disabled {
	border: 1px solid var(--grey-4);
}

.search-input {
	flex-grow:1;
}

@media (max-width: 768px) {
	.search-input {
		width: 100%;
		flex: 1 1 auto;
	}
}

div#active-filter-wrapper {
	max-width: 50vw;
	overflow-x: auto;
	min-width: 0;
	margin-right: 5px;

}

div#filter-list-wrapper::-webkit-scrollbar {
	height: 2px;
}


</style>